module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category"
  }, [_c('selector', {
    attrs: {
      "category": _vm.category,
      "categories": _vm.categories
    }
  }), _vm._v(" "), (_vm.category) ? _c('info', {
    attrs: {
      "category": _vm.category
    },
    on: {
      "edit": function($event) {
        _vm.$editCategory(_vm.category)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd685bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/category/index.vue
// module id = 907
// module chunks = 3